export const InfoObservatory = () => (
    <div className = "info-observatory">
        <div className = "title-info-observatory">
        <p>Información observatorios</p>
        </div>
        <div className = "city-observatory">
            <strong><p>SGC Manizales</p></strong>
            <p>Avenida 12 de octubre # 15-47</p>
            <p>(60 +1) 2200200 Extensión 8200</p>
            <p>sgc-manizales@sgc.gov.co</p>
        </div>
        <div className="city-observatory">
            <strong><p>SGC Popayán</p></strong>
            <p>Calle 5B # 2-14 Loma de Cartagena</p>
            <p>(60 +1) 2200200 Extensión 8600</p>
            <p>sgc-popayan@sgc.gov.co</p>
        </div>
        <div className="city-observatory">
            <strong><p>SGC Pasto</p></strong>
            <p>Calle 27 # 9 Este - 25</p>
            <p>(60 +1) 2200200 Extensión 8700</p>
            <p>sgc-pasto@sgc.gov.co</p>
        </div>
    </div>
);